var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYandexPayLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#yandex-pay-light_svg__a)"
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#fc3f1d",
  rx: 4
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#yandex-pay-light_svg__b)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "yandex-pay-light_svg__c",
  x: 5,
  y: 8,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M28 8H5v8h23z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#yandex-pay-light_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.55 8.91v6.02H18.5v-5.2h-1.87v5.21h-1.05V8.91zm1.75 6.11q-.69 0-1.06-.27v-.84q.2.14.43.22.24.08.57.08.5 0 .75-.29t.31-.81h-1.51v-.81h1.51q-.15-1-1.02-1-.27 0-.54.09a2 2 0 0 0-.41.18v-.88q.16-.09.44-.15t.67-.06q.49 0 .85.17.37.17.61.47a1.9 1.9 0 0 1 .37.72q.13.42.13.91 0 1.1-.52 1.68-.51.58-1.57.58m4.53-5.02q-.62 0-.94-.31a1.06 1.06 0 0 1-.31-.78h.87q0 .23.1.33.11.1.29.1.17 0 .26-.1.09-.11.09-.33h.87q0 .23-.08.43a.95.95 0 0 1-.23.35 1.05 1.05 0 0 1-.38.23q-.23.09-.53.09m-.76.57v2.7l1.58-2.7h.92v4.36h-.99v-2.7l-1.57 2.7h-.92v-4.36zM13.43 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc3f1d",
  d: "M9.997 14.404h.835v-4.8H9.618c-1.222 0-1.865.629-1.865 1.554 0 .739.352 1.174.981 1.623l-1.091 1.623h.905l1.215-1.816-.421-.283c-.511-.345-.76-.615-.76-1.195 0-.511.36-.857 1.043-.857h.373z"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "yandex-pay-light_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "yandex-pay-light_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5 8h23v8H5z"
})))));
export default SvgYandexPayLight;